/* Product page content sections (kalo-pdp-*). */
(function () {
  'use strict';

  // Click-to-load video: nothing loads from the video host until the visitor clicks play.
  if (!customElements.get('kalo-video-facade')) {
    customElements.define(
      'kalo-video-facade',
      class KaloVideoFacade extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('[data-facade-trigger]');
          if (!this.trigger || !this.dataset.embed) return;

          this.onClick = this.onClick.bind(this);
          this.trigger.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.trigger?.removeEventListener('click', this.onClick);
        }

        onClick(event) {
          event.preventDefault();

          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.embed;
          iframe.title = this.dataset.title || '';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.className = 'kalo-pdp-video__iframe';

          this.trigger.replaceWith(iframe);
          this.iframe = iframe;
          this.classList.add('is-playing');
          iframe.focus();
        }

        reset() {
          if (!this.iframe) return;
          this.iframe.replaceWith(this.trigger);
          this.iframe = null;
          this.classList.remove('is-playing');
        }
      }
    );
  }

  // Stop videos when the FAQ answer holding them is closed.
  document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement) || item.open) return;
      item.querySelectorAll('kalo-video-facade.is-playing').forEach((video) => video.reset());
    },
    true
  );

  // Theme editor: open a FAQ row when its block is selected.
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.matches('.kalo-pdp-faq__item')) {
      event.target.open = true;
    }
  });

  // Accordion: keeps one item open and shows the image that belongs to the open item.
  if (!customElements.get('kalo-pdp-accordion')) {
    customElements.define(
      'kalo-pdp-accordion',
      class KaloPdpAccordion extends HTMLElement {
        connectedCallback() {
          this.onToggle = this.onToggle.bind(this);
          // "toggle" does not bubble, so listen in the capture phase.
          this.addEventListener('toggle', this.onToggle, true);
        }

        disconnectedCallback() {
          this.removeEventListener('toggle', this.onToggle, true);
        }

        onToggle(event) {
          const item = event.target;
          if (!(item instanceof HTMLDetailsElement) || !item.open) return;

          // Fallback for browsers without exclusive <details name="…">.
          this.querySelectorAll('details[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });

          const frame = this.querySelector(`[data-kalo-acc-media="${item.dataset.kaloAccIndex}"]`);
          if (!frame) return;
          this.querySelectorAll('[data-kalo-acc-media].is-active').forEach((el) => el.classList.remove('is-active'));
          frame.classList.add('is-active');
        }
      }
    );
  }
})();
